"use client";

import { MotionConfig } from "motion/react";
import { ThemeProvider } from "next-themes";
import type { ReactNode } from "react";

import { ViewTransitions } from "@/lib/view-transitions";

import { SmoothScroll } from "./smooth-scroll";

// =============================================================================

/**
 * Client providers of the public website.
 * The theme follows the OS preference until the visitor picks one. The URL
 * state (nuqs) and the toasts are mounted by the pages using them, to keep
 * their code out of the other pages.
 */
export function SiteProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      // Non-executable type on the client: React treats the theme script as
      // a data block instead of warning about a script it would never run
      scriptProps={{
        type: typeof window === "undefined" ? undefined : "text/plain",
      }}
    >
      <MotionConfig reducedMotion="user">
        <ViewTransitions>
          <SmoothScroll>{children}</SmoothScroll>
        </ViewTransitions>
      </MotionConfig>
    </ThemeProvider>
  );
}

// =============================================================================
